module.exports = __webpack_public_path__ + "img/icon2.ba5d06a2.png";